// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonCreate_wrap__uD-Yt","icon":"ButtonCreate_icon__LWz6d"};